module.exports = __webpack_public_path__ + "static/media/protein.9b994a80.png";